import { createContext, useContext, useState, useMemo } from "react"

const PeriodContext = createContext(null)

export const PERIOD_OPTIONS = [
  { value: "1", label: "Last 1 Month" },
  { value: "3", label: "Last 3 Months" },
  { value: "6", label: "Last 6 Months" },
  { value: "12", label: "Last 12 Months" },
]

export function PeriodProvider({ children, defaultPeriod = "3" }) {
  const [periodMonths, setPeriodMonths] = useState(defaultPeriod)

  // Derive startDate/endDate from periodMonths (ISO YYYY-MM-DD)
  const { startDate, endDate } = useMemo(() => {
    const months = parseInt(periodMonths)
    const end = new Date()
    const start = new Date(end.getFullYear(), end.getMonth() - months, 1)
    const fmt = (d) =>
      `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, "0")}-${String(d.getDate()).padStart(2, "0")}`
    return { startDate: fmt(start), endDate: fmt(end) }
  }, [periodMonths])

  const value = useMemo(
    () => ({ periodMonths, setPeriodMonths, startDate, endDate }),
    [periodMonths, startDate, endDate]
  )

  return <PeriodContext.Provider value={value}>{children}</PeriodContext.Provider>
}

export function usePeriod() {
  const ctx = useContext(PeriodContext)
  if (!ctx) throw new Error("usePeriod must be used within PeriodProvider")
  return ctx
}
